export const userSlice = (set) => ({
    user: {
        token: null,
        role: null, //  'pros' | 'client' | 'admin' | null 
        superadmin: null
    },

    setUserToken: (token) => set((state) => ({
        user: { ...state.user, token }
    })),
    setUserRole: (role) => set((state) => ({
        user: { ...state.user, role }
    })),
    setUserSuperadmin: (superadmin) => set((state) => ({
        user: { ...state.user, superadmin }
    })),
})